import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import { api, formatApiError } from "../../lib/api";

const inputCls = "w-full bg-[#0D1117] border border-[#263342] px-4 py-3 text-sm text-slate-100 placeholder:text-slate-600 focus:outline-none focus:border-crimson transition-colors";
const labelCls = "block font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-2";

export default function UploadField({ label, value, onChange, testid }) {
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(`${process.env.REACT_APP_BACKEND_URL}/api/files/${data.path}`);
      toast.success("Photo uploaded");
    } catch (err) {
      toast.error("Upload failed", { description: formatApiError(err) });
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  return (
    <div>
      {label && <label className={labelCls}>{label}</label>}
      <div className="flex gap-2">
        <input
          className={inputCls}
          data-testid={testid}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="https://... or upload a photo"
        />
        <button
          type="button"
          data-testid={`${testid}-upload-button`}
          onClick={() => fileRef.current?.click()}
          disabled={uploading}
          className="shrink-0 flex items-center gap-2 font-mono text-xs uppercase tracking-[0.15em] border border-[#263342] px-4 text-slate-300 hover:border-crimson hover:text-crimson transition-colors disabled:opacity-60"
        >
          <Upload size={14} /> {uploading ? "Uploading" : "Upload"}
        </button>
        <input ref={fileRef} type="file" accept="image/jpeg,image/png,image/webp,image/gif" className="hidden" onChange={onFile} data-testid={`${testid}-file-input`} />
      </div>
      {value && <img src={value} alt="Preview" className="mt-2 h-20 object-cover border border-[#263342]" />}
    </div>
  );
}
